import { Col, message, Row } from "antd";
import moment from "moment";
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router";
import OtpCard from "../../../Components/OTPCArd";
import { SectionCardWrapper } from "../../../Components/UI/SectionCardWrapper";
import {
  CustomLabel,
  error_message,
  maskedMailed,
  maskPhoneNumber,
  payment_option,
  regex,
  ruppeeConverter,
  TYPE_OF_VALIDATION,
  validationOfField,
} from "../../../Constant";
import { withScroll } from "../../../HOC";
import { Payload_entry } from "../../../Redux/PolicyNumber/types";
import { postApi } from "../../../Services/apiService";
import {
  generate_orderID,
  GET_OTP,
  REVERSE_FEED,
  Validate_Otp,
} from "../../../Services/endpoints";
import { makePayment } from "../../../Services/payment";
import FooterButton from "../../Footer";
import InputFormComponent from "../InputFormComponent";
import CheckboxConsent from "./CheckBoxConsent";
import ContentComponent from "./ContentComponent";
import { decrypt, encrypt } from "../../../Services/AESEncryptionDecryption";

const SummaryPage = () => {
  const dispatch = useDispatch();
  const navigate = useNavigate();
  const [showOtp, setShowOtp] = useState(false);
  const [otpValue, setOtpValue] = useState(0);
  const [error, setError] = useState({
    pancard: false,
    email: false,
    mobile: false,
  });
  const [showProceedBtn, setShowProceedBtn] = useState(true);
  const [otpId, setOtpId] = useState("");
  const [inputAmount, setInputAmount] = useState("");
  const [userData, setUserData] = useState({
    disclaimerCheck: true,
    tncCheck: true,
    pancard: "",
    email: "",
    mobile: "",
  });
  let {  tncCheck, pancard, email, mobile } = userData;
  const [openRead, setOpenRead] = useState(false);

  const userDBData = useSelector(
    (state) => state.policyDetails.savePaymentDetails
  );

  const userDBDataExtraInfo = useSelector((state) => state.policyDetails);

  let {
    proposalType,
    paymentFor,
    policyNumber,
    proposalNumber,
    amount: userDBAmount,
    contactNum,
    emailAddress,
  } = userDBData;

  const amount = !!parseInt(userDBAmount) ? userDBAmount : inputAmount;
  let { name, firstName, lastName, isUpiAsba } = userDBDataExtraInfo;
  name = name.trim()
  
  const getOTPApi = async () => {
    const reqObject = {
      phoneNumber: mobile,
      uniqueIdentifier: `${
        policyNumber !== "" ? policyNumber : proposalNumber
      }`,
      isUpiAsba,
      ...(isUpiAsba ? { email, firstName, lastName } : {}),
    };
    const encryptedPayload = encrypt(JSON?.stringify(reqObject));
    try {
      const res = await postApi(GET_OTP, {
        encodedString: encryptedPayload
      });
      const decryptedRes = JSON?.parse(decrypt(res?.data?.response))
      if (decryptedRes?.otpId) {
        setOtpId(decryptedRes?.otpId);
        setShowOtp(true);
        return;
      }
      message.error(res?.data?.error?.errorMessage);
    } catch (err){
      console?.error(err)
    }
  };

  const validateOTP_Api = async () => {
    const reqObject = {
      otpId: otpId,
      enteredOtp: otpValue,
    };
    const encryptedPayload = encrypt(JSON?.stringify(reqObject));
    try {
      const res = await postApi(Validate_Otp, {
        encodedString: encryptedPayload
      });
      const decryptedRes = JSON?.parse(decrypt(res?.data?.response))
      if (!res?.data?.error && decryptedRes?.enteredOTPValid && (decryptedRes?.otpId === otpId)) {
        setShowOtp(false);
        setOtpValue(0);
        setShowProceedBtn(false);
        message.success("Mobile number is successfully verified");
        return;
      }
      message.error(error_message.Invalid_Otp);
    } catch {
      message.error(error_message.common_error);
    }
  };

  const paymentVerify = async (orderId, razorpay_key, customerId = "") => {
    let userLastname = name.split(" ")[name.split(" ").length - 1]
    if (name.split(" ").length === 1){
      userLastname = "NA"
    }
    let res;
    try {
      res = await makePayment({
        quoteId: "",
        isUpiAsba,
        customerId,
        totalAmount: `${parseFloat(amount) * 100}`,
        orderId,
        currency: "INR",
        name: name,
        description: `payment for policy number  ${
          policyNumber !== "" ? policyNumber : proposalNumber
        }`,
        policyNum: `${policyNumber !== "" ? policyNumber : proposalNumber}`,
        mobileNumber: mobile,
        emailId: email,
        razorpay_key,
        pancard,
        firstName: `${
          paymentFor === payment_option[0].value &&
          proposalType === "New Business"
            ? name.split(" ")[0]
            : firstName
        }`,
        lastName: `${
          paymentFor === payment_option[0].value &&
          proposalType === "New Business"
            ? userLastname
            : lastName
        }`,
      });
      dispatch({
        type: Payload_entry,
        payload: { transactionId: res.transactionId },
      });
    } catch (err) {
      console.error(err);
      return message.error(err.successMessage);
    }

    const sellBaseUrl = process.env.REACT_APP_SELL_URL;

    const payload = {
      applicationNumber: policyNumber !== "" ? policyNumber : proposalNumber,
      premiumAmount: amount,
      paymentDate: moment().format("DD/MM/YYYY"),
      proposerFirstName: res?.firstName,
      proposerLastName: res?.lastName,
      proposerMobileNumber: contactNum,
      proposerEmailId: emailAddress,
      paymentType: "DIRECTDEBIT",
      paymentStatus: res?.paymentStatus === "Success" ? 1 : 0,
      orderId: res?.orderId,
      transactionId: res?.transactionId
    };
    if (res?.paymentStatus === "Success") {
      try {
        // setTimeout(() => {
        //   document.body.classList.remove("loading-indicator-api");
        //   navigate("/thankyou", { replace: true });
        // }, 3000);
        // const apiRes = await postApi(PAYMENT_VERIFY, {
        //   ...res,
        // });
        const reverseFeedRes = await postApi(REVERSE_FEED, payload, {baseURL: sellBaseUrl});
        navigate("/thankyou", { replace: true });
      } catch (err) {
        console.error(err);
        navigate("/thankyou", { replace: true });
      }
    }
    else{
      try {
        const reverseFeedRes = await postApi(REVERSE_FEED, payload, {baseURL: sellBaseUrl});
      } catch (err) {
        console.error(err);
      }
    }
  };

  const getOrderId = async () => {
    let error = regex.PAncard.test(pancard);
    if (amount > 100000 && !error) {
      return message.error(error_message.pancard_error);
    }
    if (!!!email) {
      return message.error("Please Enter Email ID");
    }
    if (!(policyNumber || proposalNumber)) {
      return message.error("Proposal Number is required.");
    }
    if (tncCheck === false) {
      return message.error(error_message.tnc_error);
    }
    let userLastname = name.split(" ")[name.split(" ").length - 1]
    if (name.split(" ").length === 1){
      userLastname = "NA"
    }
    const reqObject = {
      uniqueIdentifier: `${
        policyNumber !== "" ? policyNumber : proposalNumber
      }`,
      totalAmount: amount,
      panNumber: pancard,
      method: isUpiAsba ? "upi" : "",
      firstName: `${
        paymentFor === payment_option[0].value &&
        proposalType === "New Business"
          ? name.split(" ")[0]
          : firstName
      }`,
      lastName: `${
        paymentFor === payment_option[0].value &&
        proposalType === "New Business"
          ? userLastname
          : lastName
      }`,
    };
    const encryptedPayload = encrypt(JSON?.stringify(reqObject));
    try {
      const res = await postApi(generate_orderID, {
        encodedString: encryptedPayload
      });
      const decryptedRes = JSON?.parse(decrypt(res?.data?.response));
      if (decryptedRes?.orderId) {
        paymentVerify(decryptedRes?.orderId, decryptedRes?.apiKey, decryptedRes?.customerId);
      }
    } 
    catch (err)
    {
      console?.error(err)
    }
  };

  useEffect(() => {
    const pNo = policyNumber !== "" ? policyNumber : proposalNumber
    if(!pNo){
      navigate("/");
    }
    setUserData({
      ...userData,
      ...{ email: emailAddress, mobile: contactNum },
    });
    return () => {};
  }, []);

  useEffect(() => {
    setUserData({
      ...userData,
      ...{ email: emailAddress, mobile: contactNum },
    });
    return () => {};
  },[contactNum,emailAddress])

  const isPanRequiredError = parseInt(amount) >= 100000 && (!Boolean(pancard) || error?.pancard)

  return (
    <div className="container">
      <Row justify="space-around" className={"cls_mghuntew_699b44"}>
        <Col lg={15} md={20} xs={24}>
          <SectionCardWrapper>
            <div className={"cls_mghuntew_95ce17"}>
              <CustomLabel font_size="30">Summary</CustomLabel>
            </div>
            <ContentComponent
              label={"Proposal Number"}
              value={`${
                policyNumber && policyNumber !== ""
                  ? policyNumber
                  : proposalNumber
              }`}
            />
            {name && <ContentComponent label={"Proposer Name"} value={name} />}
            <ContentComponent label={"Proposal Type"} value={proposalType} />
            <ContentComponent
              label={"Payment Type"}
              value={`${paymentFor?.split(" ")[0]} Payment`}
            />
            {!!parseInt(userDBAmount) ? (
              <ContentComponent
                label={"Amount"}
                value={`₹ ${ruppeeConverter(amount)}`}
              />
            ) : (
              <InputFormComponent
                label={"Amount"}
                className="user-input"
                name="Amount"
                placeholder="000000"
                disabled={!showProceedBtn}
                value={amount}
                regex={regex.decimal_only}
                onChange={(e) => setInputAmount(e.target.value)}
              />
            )}
            {emailAddress ? (
              <ContentComponent
                label={"Email ID of payer"}
                value={maskedMailed(emailAddress)}
              />
            ) : (
              <InputFormComponent
                label={"Email ID of payer"}
                className="user-input"
                name="Email ID"
                value={email}
                error={error.email}
                msg={"Enter valid Email Address"}
                placeholder="********@gmail.com"
                maxlength={60}
                onChange={(e) => {
                  setError({
                    ...error,
                    ...{
                      email: validationOfField(
                        TYPE_OF_VALIDATION.email,
                        e.target.value
                      ),
                    },
                 });
                  return setUserData({
                    ...userData,
                    ...{ email: e.target.value },
                  });
                }}
              />
            )}
            {contactNum ? (
              <ContentComponent
                label={"Mobile Number of payer"}
                value={maskPhoneNumber(contactNum)}
                isMobileNumber={true}
                onAPiCall={getOTPApi}
                showOtp={showOtp}
                showProceedBtn={showProceedBtn}
                disableNext={!parseInt(userDBAmount) && !Boolean(inputAmount)}
              />
            ) : (
              <>
                <InputFormComponent
                  label={"Mobile Number of payer"}
                  className="user-input"
                  name="Mobile Number"
                  regex={regex.numeric_only}
                  error={error.mobile}
                  msg={"Enter valid Phone Number"}
                  value={mobile}
                  disabled={!showProceedBtn}
                  showProceedBtn={showProceedBtn}
                  placeholder="12****232"
                  maxlength={10}
                  onChange={(e) => {
                    setError({
                      ...error,
                      ...{
                        mobile: validationOfField(
                          TYPE_OF_VALIDATION.Mobile,
                          e.target.value
                        ),
                      },
                    });
                    return setUserData({
                      ...userData,
                      ...{ mobile: e.target.value },
                    });
                  }}
                />
                {mobile && mobile.length > 9 && showProceedBtn && (
                  <Row>
                    <Col lg={10} md={12} xs={0}></Col>
                    <Col lg={10} md={12} xs={24}>
                      <FooterButton
                        hideBack={true}
                        nextLabel={showOtp ? "Resend OTP" : "Send OTP"}
                        onNext={getOTPApi}
                        disableNext={!parseInt(userDBAmount) && !Boolean(inputAmount)}
                      />
                    </Col>
                  </Row>
                )}
              </>
            )}
            {showOtp && (
              <Col
                lg={24}
                md={24}
                xs={24}
                span={24}
                className={"cls_mghuntex_e4a09f"}
              >
                <Row justify="center">
                  <Col lg={12} xs={24}>
                    <div>
                      <OtpCard
                        validateOtp={validateOTP_Api}
                        otpValue={otpValue}
                        setOtpValue={setOtpValue}
                        mobileNo={mobile}
                      />
                    </div>
                  </Col>
                </Row>
              </Col>
            )}
            {parseInt(amount) >= 100000 && (
              <InputFormComponent
                label={"Pan Card"}
                className="user-input"
                name="Pancard"
                value={pancard}
                error={error?.pancard}
                msg={"Enter valid PanCard"}
                placeholder="ASDA***Y"
                onChange={(e) => {
                  setError({
                    ...error,
                    ...{
                      pancard: validationOfField(
                        TYPE_OF_VALIDATION.pancard,
                        e.target.value.toUpperCase()
                      ),
                    },
                  });
                  return setUserData({
                    ...userData,
                    ...{ pancard: e.target.value.toUpperCase()},
                  });
                }}
              />
            )}
          </SectionCardWrapper>
          <Row
            justify="space-between"
            align="top"
            gutter={[0, { lg: 40 }]}
            className={"cls_mghuntex_ec4138"}
          >
            <CheckboxConsent
              isUpiAsba={isUpiAsba}
              userData={userData}
              setUserData={setUserData}
              openRead={openRead}
              setOpenRead={setOpenRead}
            />
          </Row>
          <div>
            <FooterButton
              hideBack={true}
              nextLabel="Review & Pay"
              onNext={getOrderId}
              disableNext={showProceedBtn || isPanRequiredError}
            />
          </div>
        </Col>
      </Row>
    </div>
  );
};

export default withScroll(SummaryPage);
